// Lightweight route-level loader shown while a lazy chunk downloads.
// Intentionally minimal: a slim top progress bar + neutral skeleton blocks so
// the Header (which is rendered inside each page) is not visually duplicated.
import React from 'react';

const Block = ({ className = '' }) => (
  <div
    className={`bg-slate-200/70 dark:bg-slate-800/40 rounded-md animate-pulse ${className}`}
  />
);

const PageLoader = () => {
  return (
    <div
      data-testid="route-page-loader"
      className="min-h-screen bg-white"
      aria-busy="true"
      aria-live="polite"
    >
      {/* Top progress shimmer */}
      <div className="fixed top-0 left-0 right-0 h-0.5 bg-rose-100 overflow-hidden z-[60]">
        <div className="h-full w-1/3 bg-rose-500 animate-[loaderSlide_1.2s_ease-in-out_infinite]" />
      </div>

      {/* Faux header strip */}
      <div className="h-16 border-b border-slate-100 flex items-center px-4 sm:px-6 lg:px-8 gap-4">
        <Block className="h-8 w-32" />
        <div className="hidden md:flex gap-3 ml-6">
          <Block className="h-4 w-16" />
          <Block className="h-4 w-16" />
          <Block className="h-4 w-16" />
          <Block className="h-4 w-16" />
        </div>
        <div className="ml-auto">
          <Block className="h-9 w-24 rounded-full" />
        </div>
      </div>

      {/* Hero / content skeleton */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Block className="h-8 w-2/3 max-w-lg mb-4" />
        <Block className="h-4 w-1/2 max-w-md mb-10" />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <div
              key={i}
              className="border border-slate-100 rounded-xl overflow-hidden"
            >
              <Block className="h-40 w-full rounded-none" />
              <div className="p-4 space-y-3">
                <Block className="h-4 w-3/4" />
                <Block className="h-3 w-1/2" />
                <Block className="h-8 w-24 rounded-full mt-2" />
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes loaderSlide {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(150%); }
          100% { transform: translateX(350%); }
        }
      `}</style>
    </div>
  );
};

export default PageLoader;
